import styled from "styled-components";
import { theme } from "styles/theme";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  min-height: 40vh;
  padding: 2rem;
  text-align: center;
  color: ${theme.colors.textPrimary};
`;

const Message = styled.p`
  margin: 0;
  color: ${theme.colors.textSecondary};
  max-width: 28rem;
`;

const RetryButton = styled.button`
  min-height: 44px;
  min-width: 44px;
  padding: 0.625rem 1.25rem;
  background-color: ${theme.colors.tertiary};
  color: ${theme.colors.white};
  border: none;
  border-radius: ${theme.borderRadius.small};
  font-size: ${theme.fontSizes.small};
  font-weight: ${theme.fontWeights.medium};
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${theme.colors.tertiaryDark};
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors.tertiary};
    outline-offset: 2px;
  }
`;

interface PageErrorProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

export function PageError({
  title = "Something went wrong",
  message = "Please try again later.",
  onRetry,
  retryLabel = "Try again",
}: PageErrorProps) {
  return (
    <Wrapper role="alert">
      <h2 style={{ margin: 0, fontSize: theme.fontSizes.medium }}>{title}</h2>
      <Message>{message}</Message>
      {onRetry && (
        <RetryButton type="button" onClick={onRetry}>
          {retryLabel}
        </RetryButton>
      )}
    </Wrapper>
  );
}
